module.exports = __webpack_public_path__ + "static/media/1.e4588538.webp";